let nativeDragDataEnabled = false;
export function isNativeDragDataEnabled() { return nativeDragDataEnabled; }
export function enableNativeDragData() { nativeDragDataEnabled = true; }
